import { Grid, IconButton } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';
import QuickView from 'scenes/Producer/MySales/components/Quickview';
import { Space } from 'v2/components/Shared/Space';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import salesService from 'v2/services/sales/general';

import type { IInvoice } from 'v2/interfaces/invoice';

import Details from './Details';
import Filter from './Filter';
import { NewSalesList as List } from './List';
import PeriodReport from './Reports/periodReport';

const useStyle = makeStyles((theme) => ({
  root: {
    flex: 1,
    width: '100%',
  },
  header: {
    display: 'flex',
  },
  title: {
    flex: '1',
    width: '100%',
    color: '#192542',
    '& h1': {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
    [theme.breakpoints.down('xs')]: {
      flex: 'unset',
    },
  },
  reports: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(3),
      width: '100%',
      '& > div': {
        width: '100%',
      },
    },
  },
}));

const Sales = () => {
  const classes = useStyle({});
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const [visibleQuickView, setVisibleQuickView] = useState(false);
  const [currentInvoice, setCurrentInvoice] = useState<Partial<IInvoice>>({});
  const [alert, setAlert] = useState<boolean>(localStorage.getItem('news_mysales_order_bump_2020') === 'true');

  const onCloseAlert = useCallback(() => {
    setAlert(true);
    localStorage.setItem('news_mysales_order_bump_2020', 'true');
  }, [setAlert]);

  const handleSetCurrentInvoice = useCallback((invoice: IInvoice) => {
    setVisibleQuickView(true);
    setCurrentInvoice(invoice);
  }, []);

  const handleCloseQuickView = useCallback(() => {
    setVisibleQuickView(false);
    setTimeout(() => setCurrentInvoice({}), 100);
  }, []);

  useEffect(() => {
    return () => salesService.cleanFilter();
  }, []);

  return (
    <>
      <QuickView showRefund={true} open={visibleQuickView} sale={currentInvoice} onClose={handleCloseQuickView} />

      <Grid id='my-sales' container justify='space-between' alignItems='flex-start'>
        {!alert && (
          <>
            <Alert
              style={{ width: '100%', fontWeight: 600 }}
              severity='info'
              action={
                <>
                  <IconButton onClick={onCloseAlert} aria-label='fechar'>
                    <CloseIcon />
                  </IconButton>
                </>
              }
            >
              Novidades na plataforma! Agora você pode consultar suas vendas de Order Bump em nossas opções de Filtros Avançados. Ainda não conhece
              essa funcionalidade?
              <br />
              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807006190-Aumente-suas-vendas-conhe%C3%A7a-o-Order-Bump-'
              >
                Clique aqui e descubra como aumentar o seu ticket médio com o Order Bump!
              </a>
            </Alert>
            <div className='m32' />
          </>
        )}
        <div className={classes.title}>
          <h1>Minhas Vendas</h1>
          <p>Gerencie suas vendas.</p>
        </div>
        <div className={classes.reports}>
          <PeriodReport />
        </div>
      </Grid>

      <Space axis='vertical' size={32} />

      <Filter />
      <Details />
      <List handleSetCurrentInvoice={handleSetCurrentInvoice} />
    </>
  );
};

export default Sales;
